jQuery(function ($) {

    // Variables
    __window = $(window);
    __body = $('body');
    __header = $('header');
    __footer = $('footer');

    // Responsive values
    xl = "1440";
    lg = "1280";
    md = "768";
    sm = "556";
    xs = "320";

    // Window width and height values
    __winwidth = __window.width();
    __winheight = __window.height();

    // All Resoultion

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        // console.log('Safari on Mac detected, applying class...');
        jQuery('body').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
    }
    jQuery('#file-upload, #contact-file-upload').click(function (e) {
        let checkIdElement = document.getElementById("captcha_contact_form");
        const filestackClient = filestack.init('AQMLapOvSuOeCUTEwxVghz');
        if (checkIdElement) {
            const options = {
                fromSources: ["local_file_system", "url", "googledrive", "dropbox"],
                accept: [
                    "image/jpeg", "image/jpg", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/msword", "image/png", "text/plain", "application/vnd.ms-powerpoint",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/pdf"
                ],
                onUploadDone: uploadFileForm2,
                maxSize: 20 * 1024 * 1024,
                maxFiles: 20,
                uploadInBackground: true,
                startUploadingWhenMaxFilesReached: true,
            };
            filestackClient.picker(options).open();
        } else {
            let maxSizeLimit = 20 * 1024 * 1024;
            let errorDivId = null;
            let pickerInstance = null;
            let customErrorMessage = "🚫 Sorry! Your file is over the 25 mb limit. For larger files, please use <a href='https://www.prioritytranslate.com/free-quote' target='_blank'>this link</a> to submit your request.";
            let quoteErrorMessage = "🚫 Sorry! Your file is over the 100 mb limit. For larger files, Please reach out to support@prioritytranslate.com for more assistance.";

            const currentPath = window.location.pathname;

            if (currentPath.includes("/free-quote")) {
                maxSizeLimit = 100 * 1024 * 1024;
                errorDivId = "free-quote-file-limit-error";
            } else if (currentPath.includes("/order-now")) {
                maxSizeLimit = 25 * 1024 * 1024;
                errorDivId = "order-now-file-limit-error";
            }
            
            function showErrorMessage() {
                if (!errorDivId) return;

                const errorDiv = document.getElementById(errorDivId);
                if (errorDiv) {
                    // Use the quote error message for /free-quote page, otherwise use the custom message
                    const errorMessage = currentPath.includes("/free-quote") ? quoteErrorMessage : customErrorMessage;
                    errorDiv.innerHTML = errorMessage;
                    errorDiv.style.display = "block";
                }

                errorTimeout = setTimeout(() => {
                    if (errorDiv) errorDiv.style.display = "none";
                }, 5000);
            }

            function validateFileSize(files) {
                for (let file of files) {

                    if (file.size > maxSizeLimit) {
                        showErrorMessage();
                        return false;
                    }
                }
                return true;
            }
            
            const options = {
                fromSources: ["local_file_system", "url", "googledrive", "dropbox"],
                accept: [
                    "image/jpeg", "image/jpg", "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    "application/msword", "image/png", "text/plain", "application/vnd.ms-powerpoint",
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/pdf"
                ],
                onUploadDone: uploadFileForm,
                maxFiles: 20,
                uploadInBackground: true,
                startUploadingWhenMaxFilesReached: true,
                onFileSelected: file => {
                    if (errorDivId) {
                        const errorDiv = document.getElementById(errorDivId);
                        if (errorDiv) {
                            errorDiv.style.display = "none";
                        }
                    }

                    if (!validateFileSize([file])) {

                        if (pickerInstance) pickerInstance.close();
                        return false;
                    }
                },
            };
            pickerInstance = filestackClient.picker(options);
            pickerInstance.open();
        }

    });
    jQuery('.order-form .form-sec input[type="radio"]').click(function () {
        jQuery(this).parent().parent().addClass('checked');
        jQuery(this).parent().parent().siblings().removeClass('checked');
    });

    jQuery('.accordion-header').click(function () {
        jQuery(this).parent().toggleClass('open');
        jQuery(this).parent().siblings().removeClass('open');
    })

    /* For iOS touch hover effect */
    document.addEventListener("touchstart", function () { }, false);

});

function uploadFileForm(result) {
    for (const fileData of result.filesUploaded) {
        const uploadedHTML = $('<div id="' + fileData.handle + '" class="upload-row"><span class="filename">' + fileData.filename + '</span><button class="delete-file" onclick="jQuery(\'#' + fileData.handle + '\').fadeOut().remove();jQuery(\'.' + fileData.handle + '\').remove();jQuery(\'#uploadedfiles h5 strong.noofuploads\').text(jQuery(\'.uploadedfile\').length);">Remove</button></div>');
        jQuery('#uploadedfiles').removeClass('d-none').append(uploadedHTML);

        jQuery('.custom-file-upload').append($('<input type="hidden" name="files[]" class="' + fileData.handle + ' uploadedfile" value="' + fileData.url + '"/>'));
        uploadedHTML.find('.remove-file').attr('data-handle', fileData.handle).attr('data-filename', fileData.filename);
        $('.custom-file-upload').append(
            $('<input type="hidden" name="file_names[]" class="' + fileData.handle + ' uploadedfilename" value="' + fileData.filename + '"/>')
        );
        addFileName(fileData.filename);
    }
    jQuery('#uploadedfiles h5 strong.noofuploads').text(jQuery('.uploadedfile').length);
    jQuery('.file-upload .alert-danger').remove();
}

const observer = new MutationObserver(() => {
    const altTextElements = document.querySelectorAll('.fsp-summary__alttext');

    if (altTextElements.length > 0) {
        altTextElements.forEach(el => el.remove());
    }
});

observer.observe(document.body, { childList: true, subtree: true });

function addFileName(filename) {
    let fileNames = $('input[name="file_names"]').val();
    fileNames = fileNames ? fileNames.split(',') : [];
    fileNames.push(filename);
    $('input[name="file_names"]').val(fileNames.join(','));
}

function removeFileName(filename) {
    let fileNames = $('input[name="file_names"]').val();
    fileNames = fileNames ? fileNames.split(',') : [];
    fileNames = fileNames.filter(name => name !== filename);
    $('input[name="file_names"]').val(fileNames.join(','));
}

$(document).on('click', '.delete-file', function() {
    const handle = $(this).data('handle');
    const filename = $(this).data('filename');
    $('#' + handle).fadeOut().remove();
    $('.' + handle).remove();
    removeFileName(filename);

});

function showUploadedFiles() {
    if (jQuery('input.uploadedfile').length) {
        jQuery('input.uploadedfile').each(function (i, elem) {
            const handle = $(elem).val().replace('https://cdn.filestackcontent.com/', '');
            jQuery.getJSON("https://www.filestackapi.com/api/file/" + handle + "/metadata", function (data) {
                if (data.filename) {
                    const uploadedHTML = $('<div id="' + handle + '" class="upload-row"><span class="filename">' + data.filename + '</span></div>');
                    jQuery('#uploadedfiles').removeClass('d-none').append(uploadedHTML);
                    $('#uploadedfiles').append(
                        $('<input type="hidden" name="file_names[]" class="' + handle + ' uploadedfilename" value="' + data.filename + '"/>')
                    );
                    addFileName(data.filename);
                }
                jQuery('#uploadedfiles h5 strong.noofuploads').text(jQuery('.uploadedfile').length);
            });
        });
    }
}

function quizUploadedFiles() {
    if (jQuery('input.uploadedfile').length) {
        jQuery('input.uploadedfile').each(function (i, elem) {
            const handle = $(elem).val().replace('https://cdn.filestackcontent.com/', '');
            jQuery.getJSON("https://www.filestackapi.com/api/file/" + handle + "/metadata", function (data) {
                if (data.filename) {

                    const uploadedHTML = $('<div id="' + handle + '" class="upload-row"><span class="filename">' + data.filename + '</span><button class="delete-file" onclick="jQuery(\'#' + handle + '\').fadeOut().remove();jQuery(\'.' + handle + '\').remove();jQuery(\'#uploadedfiles h5 strong.noofuploads\').text(jQuery(\'.uploadedfile\').length);">Remove</button></div>');
                    uploadedHTML.find('.remove-file').attr('data-handle', handle).attr('data-filename', data.filename);
                    jQuery('#uploadedfiles').removeClass('d-none').append(uploadedHTML);

                }
                jQuery('#uploadedfiles h5 strong.noofuploads').text(jQuery('.uploadedfile').length);
            });
        });
    }
}

function showUploadedFiles2() {
    if (jQuery('input.uploadedfile').length) {
        jQuery('input.uploadedfile').each(function (i, elem) {
            const handle = $(elem).val().replace('https://cdn.filestackcontent.com/', '');
            jQuery.getJSON("https://www.filestackapi.com/api/file/" + handle + "/metadata", function (data) {
                if (data.filename) {
                    const uploadedHTML = $('<div id="' + handle + '" class="upload-row"><span class="filename">' + data.filename + '</span><span class="file-check-icon"></span></div>');
                    jQuery('#uploadedfiles').removeClass('d-none').append(uploadedHTML);
                }
                jQuery('#file-count').text(jQuery('.uploadedfile').length);
            });
        });
    }
}
function uploadFileForm2(result) {
    for (const fileData of result.filesUploaded) {
        const uploadedHTML = $('<div id="' + fileData.handle + '" class="upload-row"><span class="filename">' + fileData.filename + '</span> <span class="filesize">' + parseInt(fileData.size / 1000) + 'kb</span><span class="file-check-icon"></span></div>');
        jQuery('#uploadedfiles').removeClass('d-none').append(uploadedHTML);
        jQuery('.custom-file-upload').append($('<input type="hidden" name="files[]" class="' + fileData.handle + ' uploadedfile" value="' + fileData.url + '"/>'));
    }
    jQuery('#file-count').text('x' + jQuery('.uploadedfile').length);
    jQuery('.file-upload .alert-danger').remove();
}

function getPrices() {
    var jsonPrices = jQuery('input[name="currency_prices"]').val()
    if(jsonPrices){
        var prices = JSON.parse(jsonPrices);
    } else {
        var prices = '';
    }
    return prices;
}

function getNoOfPages() {
    const element = jQuery('[name="no_of_page"]:visible')

    let no_of_page = 0;
    if (element.length && element.is('input')) {
        no_of_page = parseFloat(element.val());
    } else {
        no_of_page = parseFloat(element.find('option:selected').val());
    }
    return no_of_page;
}

function calculateTotal() {
    let total = 0, discount = 0, no_of_page = 0, surcharge_price= 0;
    if (jQuery("#standard-translation").is(":checked")) {
        no_of_page = parseFloat(jQuery('#no_of_words').val());
        if (!no_of_page) {
            no_of_page = 0;
        }
    } else {
        // no_of_page = parseFloat(jQuery('#no_of_page option:selected').val());
        no_of_page = getNoOfPages();
    }
    const service = jQuery('input[name="service"]:checked').length ? parseFloat(jQuery('input[name="service"]:checked').val()) : 0;
    const delivery = jQuery('input[name="delivery"]:checked').length ? parseFloat(jQuery('input[name="delivery"]:checked').val()) : 0;
    let checkboxElement = document.getElementById("surcharge_price");
    if (checkboxElement) {
        surcharge_price = parseFloat(jQuery(checkboxElement).val());
    }
    if (no_of_page >= 1) {
        total = ((no_of_page * service) + delivery + surcharge_price);
    }

    jQuery('#order-total').text(total.toFixed(2));
    if (jQuery('input[name="discount"]').length) {
        discount = parseFloat(jQuery('input[name="discount"]').val());
        total = total - (total * (discount / 100));
        jQuery('#discount-total').text(total.toFixed(2));
    }
    jQuery('input[name="total"]').val(total.toFixed(2));
    jQuery('#coupon-order-total').val(total.toFixed(2));
    var order_total = total.toFixed(2);
    var prices = getPrices();
    var paypalPrice = order_total;

    if (prices['CC'] != 'USD' && checkCurrency(prices['CC'])) {
        paypalPrice = truncateNumber(order_total / prices['CR'],2).toFixed(2);
    }
    jQuery('input[name="paypal_total"]').val(paypalPrice);
}

function AbandonUploadedFiles() {
    if (jQuery('input.uploadedfile').length) {
        jQuery('input.uploadedfile').each(function (i, elem) {
            const handle = $(elem).val().replace('https://cdn.filestackcontent.com/', '');
            jQuery.getJSON("https://www.filestackapi.com/api/file/" + handle + "/metadata", function (data) {
                if (data.filename) {
                    const uploadedHTML = $('<div id="' + handle + '" class="upload-row"><span class="filename">' + data.filename + '</span><button class="delete-file" onclick="jQuery(\'#' + handle + '\').fadeOut().remove();jQuery(\'.' + handle + '\').remove();jQuery(\'#uploadedfiles h5 strong.noofuploads\').text(jQuery(\'.uploadedfile\').length);">Remove</button></div>');
                    uploadedHTML.find('.remove-file').attr('data-handle', handle).attr('data-filename', data.filename);
                    jQuery('#uploadedfiles').removeClass('d-none').append(uploadedHTML);
                }
                jQuery('#uploadedfiles h5 strong.noofuploads').text(jQuery('.uploadedfile').length);
            });
        });
    }
}


function checkCurrency(code){
    var paypal_currencies = ['USD','AUD','CAD','CHF','CZK','DKK','EUR','GBP','HKD','HUF','ILS','JPY','MXN','NOK','NZD','PHP','PLN','RUB','SEK','THB']
    if (paypal_currencies.includes(code)) {
        return false;
    } else {
        return true;
    }
}

function truncateNumber(num, decimalPlaces) {
    var factor = Math.pow(10, decimalPlaces);
    return Math.floor(num * factor) / factor;
}

jQuery(document).ready(function () {
    jQuery('[name="no_of_page"], input[name="service"], input[name="delivery"], input[name="translation"], #no_of_words').change(function () {
        calculateTotal();
    });
    calculateTotal();

    let checkIdElement = document.getElementById("new-order-form");
    let pathSegments = window.location.pathname.split('/');

    if (pathSegments.length > 2 && pathSegments[1] === "order-now") {
        let token = pathSegments[2];
        localStorage.setItem("orderToken", token);
    } else {
        localStorage.removeItem("orderToken");
    }

    if(!localStorage.getItem('orderToken')) {
        if (checkIdElement) {
            showUploadedFiles2();
        } else {
            let quizOrder = localStorage.getItem("quiz-order-session");

            if (quizOrder && $("#isQuiz").val() === '1') {
                quizOrder = JSON.parse(quizOrder);

                if (Array.isArray(quizOrder.files) && quizOrder.files.length > 0) {
                    $.each(quizOrder.files, function (index, file) {
                        let fileUrl = file.url;
                        let fileHandle = fileUrl.replace("https://cdn.filestackcontent.com/", "");

                        let inputField = `<input type="hidden" name="files[]" class="${fileHandle} uploadedfile" value="${fileUrl}" />`;
                        $("#file-upload").append(inputField);
                    });
                }
                quizUploadedFiles();
            } else {
                showUploadedFiles();
            }
        }
    }else {
        AbandonUploadedFiles()
    }

    function showShippingFields() {
        if (jQuery('#delivery-email').is(':checked') || jQuery('#delivery-notarized-email').is(':checked')) {
            jQuery('#sameshipping').hide();
        } else {
            jQuery('#sameshipping').show();
        }
    }
    showShippingFields();
    jQuery('input[name="delivery"]').change(function () {
        showShippingFields();
    });


    jQuery('#from_lng').change(function () {
        if (jQuery('#from_lng option:selected').val().trim() !== 'English (US)') {
            jQuery('#to_lng').val('English (US)').trigger('change');
            jQuery('#to_lng [value="English (US)"]').attr('selected', 'true');
        } else {
            jQuery('#to_lng').val('').trigger('change');
            jQuery('#to_lng [value=""]').attr('selected', true);
        }
    });
});
jQuery(window).on('load resize', function () {
    __window = $(window);
    __winwidth = __window.width();
    __winheight = __window.height();

    if (__winwidth < 992) {
        // Wait for OwlCarousel to be available
        if (typeof $.fn.owlCarousel !== 'undefined') {
            $('.owl-carousel').owlCarousel({
            loop: true,
            margin: 10,
            autoHeight: true,
            //responsiveClass:true,
            responsive: {
                0: {
                    items: 1,
                    //nav:true
                },
                768: {
                    items: 2,
                    //nav:false
                }
            }
        });
        }
    }
});
document.addEventListener("DOMContentLoaded", function () {
    let checkIdElement = document.getElementById("user_based_price");
    if (checkIdElement) {
        var prices = JSON.parse(checkIdElement.value);
        if (prices) {
            var csPrice = prices['CS'];
            var rsPrice = prices['RS'];
            var ccPrice = prices['C_C'];
            var concatenatedPrice = csPrice + rsPrice + ' ' + ccPrice;
            let regularServicePriceSpan = document.getElementsByClassName("regular-service-price");
            for (let i = 0; i < regularServicePriceSpan.length; ++i) {
                regularServicePriceSpan[i].textContent = concatenatedPrice;
            }
        }

    }

});
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        var alertElement = document.querySelector(".alert");
        if (alertElement) {
            alertElement.style.transition = "opacity 0.5s";
            alertElement.style.opacity = "0";
            setTimeout(function () {
                alertElement.remove();
            }, 500);
        }
    }, 10000);
});
document.addEventListener("DOMContentLoaded", function () {
    const emailInput = document.getElementById("contact-email");

    if (emailInput) {
        emailInput.addEventListener("blur", function () {
            const email = emailInput.value;
            var div = document.getElementById('contact-email-error');

            if (!validateEmail(email)) {

                div.innerHTML = 'Please enter a valid email address.';
                document.getElementById("contact-form-submit").disabled = true;

            } else {
                div.innerHTML = '';
                document.getElementById("contact-form-submit").disabled = false;

            }

        });
    }
});
function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
jQuery(document).ready(function () {
    jQuery("#toggle-button").click(function () {
        var elem = jQuery("#toggle-button").text();
        if (elem == "See More") {
            //Stuff to do when btn is in the read more state
            jQuery("#toggle-button").text("See Less");
            jQuery(".hidden-content").slideDown();
        } else {
            //Stuff to do when btn is in the read less state
            jQuery("#toggle-button").text("See More");
            jQuery(".hidden-content").slideUp();
        }
    });


    $('.tab-menu li a').on('click', function(){
            var target = $(this).attr('data-rel');
            $('.tab-menu li a').removeClass('active');
            $(this).addClass('active');
            $("#"+target).fadeIn('slow').siblings(".tab-box").hide();
            return false;
    });
    var element_flash = document.getElementById('flash-sale-banner-1');
    if (element_flash) {
    // Initialize the timer for banner 1 and 2
    // setInterval(function () { makeTimerGetStarted(); }, 1000);
    // if (typeof timeLeft !== "undefined") {
    //     makeTimerGetStarted(timeLeft);
    // }
    setInterval(function () { makeTimerGetStarted1(); }, 1000);


    // Make banner 1 visible after 2 seconds
    setTimeout(function () {
        document.body.classList.add('flash-sale-banner-open');
        var banner1 = document.querySelector('#flash-sale-banner-1');
        banner1.style.visibility = 'visible';
        banner1.style.top = '0';
        banner1.style.position = 'fixed';
        banner1.style.zIndex = '9';
    }, 2000);

    // Close Banner 1 and show Banner 2 when close button of Banner 1 is clicked
    document.querySelector('#flash-sale-banner-1 .flash-close-btn').addEventListener('click', function (e) {
        e.preventDefault();
        var bodyBannerClass = document.querySelector('.flash-sale-banner-open');
     if (bodyBannerClass) {
         bodyBannerClass.classList.remove('flash-sale-banner-open');
       }
        // Hide Banner 1
        var banner1 = document.querySelector('#flash-sale-banner-1');
        banner1.style.visibility = 'hidden';
        banner1.style.top = '0';
    });

    // Timer function for both banners
    function makeTimerGetStarted1() {
        var userLang = document.querySelector('html').lang;
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var pstDate = new Date().toLocaleString("en-US", { timeZone: 'America/Los_Angeles' });
        var current = new Date(pstDate);
        var currentHour = current.getHours();
        var current_date = '';
        if (currentHour >= 0 && currentHour < 6) {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 06:00:00";
        } else if (currentHour > 5 && currentHour < 12) {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 12:00:00";
        } else if (currentHour > 11 && currentHour < 18) {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 18:00:00";
        } else {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 00:00:00";
        }
        var endTime = new Date(current_date);
        endTime = Date.parse(endTime) / 1000;
        var now = Date.parse(current) / 1000;
        var timeLeft = endTime - now;
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor((timeLeft - days * 86400) / 3600);
        var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
        var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }

        var flashSaleBannerDivs = document.querySelectorAll('.winter_sale_flash_banner');
        flashSaleBannerDivs.forEach(function(flashSaleBannerDiv) {
            const hourElement = flashSaleBannerDiv.querySelector('.sale_hour');
            const minuteElement = flashSaleBannerDiv.querySelector('.sale_minute');
            const secondElement = flashSaleBannerDiv.querySelector('.sale-second');

            if (hourElement) hourElement.textContent = hours;
            if (minuteElement) minuteElement.textContent = minutes;
            if (secondElement) secondElement.textContent = seconds;
        });
    }

    function makeTimerGetStarted(timeLeft) {
        var hours = 0;
        var minutes =0;
        var seconds = 0;

        if (hours == 0 && minutes == 0 && seconds == 0){

            setInterval(function () { makeTimerGetStarted1(); }, 1000);
            return;
        }
        // Ensure proper formatting
        function formatNumber(num) {
            return num < 10 ? "0" + num : num;
        }

        function updateTimerDisplay() {
            var flashSaleBannerDivs = document.querySelectorAll('.winter_sale_flash_banner');
            flashSaleBannerDivs.forEach(function (flashSaleBannerDiv) {
                flashSaleBannerDiv.querySelector('.sale_hour').textContent = formatNumber(hours);
                flashSaleBannerDiv.querySelector('.sale_minute').textContent = formatNumber(minutes);
                flashSaleBannerDiv.querySelector('.sale-second').textContent = formatNumber(seconds);
            });
        }

        updateTimerDisplay();

        var interval = setInterval(function () {
            if (hours === 0 && minutes === 0 && seconds === 0) {
                clearInterval(interval);
                return;
            }

            seconds--;

            if (seconds < 0) {
                seconds = 59;
                minutes--;

                if (minutes < 0) {
                    minutes = 59;
                    hours--;
                }
            }
            updateTimerDisplay();
        }, 1000);
    }

}

var element_flash2 = document.getElementById('flash-sale-banner-2');
if (element_flash2) {

    // Show banner 2 after 15 seconds (if necessary)
    setTimeout(function () {
        document.body.classList.add('flash-sale-banner-open');
        var banner2 = document.querySelector('#flash-sale-banner-2');
        banner2.style.visibility = 'visible';
        banner2.style.transition = 'opacity 1s';
        banner2.style.opacity = 1;
        banner2.style.top = '0';
        banner2.style.position = 'fixed';
        banner2.style.zIndex = '10';
    }, 2000);

    setInterval(function () { makeTimerGetStarted2(); }, 1000);

    // Close Banner 2 on close button click and remove 'flash-sale-banner-open' class from body
    document.querySelector('#flash-sale-banner-2 .flash-close-btn').addEventListener('click', function (e) {
        e.preventDefault();
        var bodyBannerClass = document.querySelector('.flash-sale-banner-open');
         if (bodyBannerClass) {
             bodyBannerClass.classList.remove('flash-sale-banner-open');
           }
        // Hide Banner 2
        var banner2 = document.querySelector('#flash-sale-banner-2');
        banner2.style.visibility = 'hidden';
        banner2.style.top = '0';

        // Remove the 'flash-sale-banner-open' class from body
        document.body.classList.remove('flash-sale-banner-open');
    });

    // Timer function for Winter Sale (PST-based countdown)
    function makeTimerGetStarted2() {
        var userLang = document.querySelector('html').lang;
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var pstDate = new Date().toLocaleString("en-US", { timeZone: 'America/Los_Angeles' });
        var current = new Date(pstDate);
        var currentHour = current.getHours();
        var current_date = '';
        if (currentHour >= 0 && currentHour < 6) {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 06:00:00";
        } else if (currentHour > 5 && currentHour < 12) {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 12:00:00";
        } else if (currentHour > 11 && currentHour < 18) {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 18:00:00";
        } else {
            current_date = current.getDate() + " " + months[current.getMonth()] + " " + current.getFullYear() + " 00:00:00";
        }
        var endTime = new Date(current_date);
        endTime = Date.parse(endTime) / 1000;
        var now = Date.parse(current) / 1000;
        var timeLeft = endTime - now;
        var days = Math.floor(timeLeft / 86400);
        var hours = Math.floor((timeLeft - days * 86400) / 3600);
        var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
        var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }
        var flashSaleBannerDivs = document.querySelectorAll('.winter_sale_flash_banner');
        flashSaleBannerDivs.forEach(function(flashSaleBannerDiv) {
            flashSaleBannerDiv.querySelector('.sale_hour').textContent = hours;
            flashSaleBannerDiv.querySelector('.sale_minute').textContent = minutes;
            flashSaleBannerDiv.querySelector('.sale-second').textContent = seconds;
        });
    }
}

});

// Fetch CSRF token dynamically via AJAX
function getCsrfToken() {
    return fetch('/csrf-token')
        .then(response => response.json())
        .then(data => data.csrf_token);
}

var element_std_free_quote = document.getElementById('std-free-quote');
if (element_std_free_quote) {
    element_std_free_quote.addEventListener('click', function (event) {
        event.preventDefault();
        setFormData(this);
    });
}

var element_order_quote_cta = document.getElementById('order-quote-cta');
if (element_order_quote_cta) {
    element_order_quote_cta.addEventListener('submit', (event) => {
        event.preventDefault();
        // pass the button that triggered the submit
        setFormData(event.submitter);
    });
}

function setFormData(element) {
    const pageName = window.location.pathname.replace(/^\/+/, '');
    const fromLanguage = document.getElementById('from_lng').value;
    const toLanguage = document.getElementById('to_lng').value;
    const action = element.dataset.value || 'Free-Quote'; // fallback if missing
    const endpoint = 'languageSelected';

    // Create the request body
    const payload = {
        fromLanguage,
        toLanguage,
        action,
    };

    getCsrfToken().then(csrfToken => {
        return fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify(payload),
        });
    }).then(response => {
        if (!response.ok) {
            throw new Error(`Request failed with status: ${response.status}`);
        }
        return response.json();
    }).then(responseData => {
        if (responseData.redirect === 'order') {
            window.location = '/order-now';
        } else if (responseData.redirect === 'quote') {
            window.location = 'free-quote';
        }
    }).catch(error => {
        console.error('Connection error:', error);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    const video = document.getElementById('myVideo');
    const playButton = document.getElementById('playButton');
    if(playButton){
        playButton.addEventListener('click', function() {
            video.play();
            video.setAttribute('controls', 'controls');
            playButton.style.display = 'none';
        });
    }
    if(video){
        video.addEventListener('pause', function() {
            playButton.style.display = 'flex';
        });
    }
    if(video){
        video.addEventListener('play', function() {
            playButton.style.display = 'none';
            video.setAttribute('controls', 'controls');
        });
    }
    if(video){
        video.addEventListener('ended', function() {
            playButton.style.display = 'flex';
            video.removeAttribute('controls');
            video.load(); // Resets the video to show the poster image
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {

    // Get the referrer URL
    var referrerUrl = document.referrer;

    // Get the pathname of the current URL
    var currentPathname = window.location.pathname;

    var referrerPathname = '';

    // Get the pathname of the referrer URL, if available
    if (referrerUrl) {
        var referrerPathname = new URL(referrerUrl).pathname;
    }
    if (referrerPathname === "/ircc-translation" && currentPathname === '/') {
        document.getElementById("page-refer-heading-home").textContent="100% IRCC Acceptance Guarantee";
        document.getElementById("page-refer-para-home").textContent="Accepted by IRCC and many other government agencies.";
        document.getElementById("page-refer-faq2-home").textContent="A certified translation is a word-for-word human translation of your documents by a professional translator. It includes a Rapid Translate letterhead that contains a signed and stamped certificate of translation accuracy for official use purposes required by the IRCC (Canadian Immigration), as well as universities, courts, and many other local and provincial governments.";
        document.getElementById("page-refer-faq8-head-home").textContent="How do you ensure IRCC acceptance?";
        document.getElementById("page-refer-faq8-home").textContent="Our IRCC acceptance guarantee offers a money-back assurance if your documents are not approved, including complimentary revisions to ensure approval.";
        document.getElementById("page-refer-logo-home").innerHTML="<img src='/images/immigration-refugees.svg')' alt='Immigration Refugees'/>";
        document.getElementById("page-refer-link-home").innerHTML="<a href='/ircc-translation'>IRCC</a>";
    }

    if (referrerPathname === "/ukvi-translation" && currentPathname === '/') {
        document.getElementById("page-refer-heading-home").textContent="100% UKVI Acceptance Guarantee";
        document.getElementById("page-refer-para-home").textContent="Accepted by UKVI and many other government agencies.";
        document.getElementById("page-refer-faq2-home").textContent="A certified translation is a word-for-word human translation of your documents by a professional translator. It includes a Rapid Translate letterhead that contains a signed and stamped certificate of translation accuracy for official use purposes required by the UKVI (UK Immigration), as well as universities, courts, and many other local and regional governments.";
        document.getElementById("page-refer-faq8-head-home").textContent="How do you ensure UKVI acceptance?";
        document.getElementById("page-refer-faq8-home").textContent="Our UKVI acceptance guarantee offers a money-back assurance if your documents are not approved, including complimentary revisions to ensure approval.";
        document.getElementById("page-refer-logo-home").innerHTML="<img src='/images/uk-visas.svg' alt='uk-visa'>";
        document.getElementById("page-refer-link-home").innerHTML="<a href='/ukvi-translation'>UKVI</a>";
        document.getElementById("page-refer-lang-link-home").innerHTML="<a href='/english-uk-translation'><img src='/images/united-kingdom-flag.svg' alt='flag'><span>English (UK)</span></a>";
    }

    if (referrerPathname === "/ircc-translation" || currentPathname === '/ircc-translation') {
        document.getElementById("page-refer-logo-footer").innerHTML="<img src='/images/immigration-refugees-color.svg' alt='Immigration Refugees' />";
    }

    if (referrerPathname === "/ukvi-translation" || currentPathname === '/ukvi-translation' || currentPathname == '/english-uk-translation') {
        document.getElementById("page-refer-logo-footer").innerHTML="<img src='/images/uk-visas-color.svg' alt='UK Visas' />";
    }

    if ((referrerPathname === "/ukvi-translation" && currentPathname === '/') || currentPathname === '/ukvi-translation' || currentPathname == '/english-uk-translation') {
        const anchorTag = document.querySelector('.Page-items a');
        const pageItemsElement = document.querySelector('.Page-items');
        if (anchorTag && pageItemsElement) {
            ukviUrl = pageItemsElement.dataset.ukviUrl;
            anchorTag.href = ukviUrl;
            anchorTag.textContent = "UKVI";
        }
    }

    const usCard = document.querySelector('.us-card');
    const ukCard = document.querySelector('.uk-card');

    if (currentPathname.includes('/english-us-translation')) {
      usCard.style.display = 'none';
      ukCard.style.display = 'block';
    } else if (currentPathname.includes('/english-uk-translation')) {
      ukCard.style.display = 'none';
      usCard.style.display = 'block';
    }

    const pages = ['drivers-license-translation', 'apostille-translation', 'uscis-certified-translation',
    'birth-certificate-translation', 'academic-transcript-translation', 'legal-translation',
    'medical-translation', 'business-documents', 'death-certificate-translation'];
      pages.forEach(page => {
          if (window.location.pathname.includes(page)) {
              var anchorTag = document.querySelector(`.popular-documents-list-items a[href*="${page}"]`);
              if (anchorTag) {
                  anchorTag.removeAttribute('href');
              }
          }
      });

    // function checkLanguage() {
    //     const specialLanguages = ['French', 'Spanish', 'German'];
    //     var fromLang = $('#from_lng').val();
    //     var toLang = $('#to_lng').val();
    //     var showSpecializedTranslation = specialLanguages.includes(fromLang) || specialLanguages.includes(toLang);

    //         if (showSpecializedTranslation) {
    //             $('#specialized-translation-div').slideDown();  // Show specialized translation option
    //         } else {
    //             $('#specialized-translation-div').slideUp();  // Hide specialized translation option
    //             $("#certified-translation").checked('true');
    //             $("#specialized-translation").checked('false');
    //             calculateTotal();
    //         }
    // }

    // $('#from_lng, #to_lng').on('change', function() {
    //     checkLanguage();
    // });

});

jQuery(document).on("click", "#need_help_btn", function (e) {
    e.preventDefault(); // Prevent default behavior
    if(localStorage.getItem("info-session-sent")) {
        localStorage.removeItem("info-session-sent");
    }

    if(localStorage.getItem("quiz-order-visit-sent")) {
        localStorage.removeItem("quiz-order-visit-sent");
    }

    if(localStorage.getItem("quiz-order-session")) {
        localStorage.removeItem("quiz-order-session");
    }

    const currentGroup = localStorage.getItem("quizAllSiteGroup");

    quizOrderSession = {
        visit_group: currentGroup,
        timestamp: new Date().toISOString() // Optional: store the time
    };
    
    localStorage.setItem("quiz-order-session", JSON.stringify(quizOrderSession));

    const input = document.getElementById('recommendationQuizUrl');

    if (input && input.value) {
        window.location.href = input.value;
    }
});

$(document).ready(function () {
    handleCounterAnimation();

    // Owl Carousel Accessibility Enhancements for Screen Readers 
    $(function(){
        if ($('.owl-carousel').length) {
            $('.owl-carousel').each(function () {
                enhanceOwlAccessibility(this);
            });
        }
    });
});

/**
 * Counter Animation Handler
 *
 * This script dynamically animates numerical counters on the About page, 
 * providing a smooth counting effect from zero to target values. 
 * It first checks for the presence of statistical counter elements 
 * (`counter1` through `counter5`), then calculates and formats the target 
 * values based on currency settings and hidden input data.
 * 
 * The animation uses a custom easing function for a smooth visual experience 
 * and adapts its duration depending on the size of the number and the 
 * specific counter's ID. This enhances the user interface by making 
 * statistical data more engaging and visually appealing.
 *
 * Core Functions:
 * - handleCounterAnimation(): Initializes counters and triggers animations.
 * - animateCounterSmooth(): Animates the count using requestAnimationFrame.
 */


function handleCounterAnimation() {
    const AboutStats = document.getElementsByClassName('fast-accurate-translation-items');
    if (!AboutStats || AboutStats.length === 0) return;

    const counter1 = document.getElementById('counter1');
    const counter2 = document.getElementById('counter2');
    const counter3 = document.getElementById('counter3');
    const counter4 = document.getElementById('counter4');
    const counter5 = document.getElementById('counter5');

    const hiddenCountInput = document.querySelector('input[name="js-document-count"]');
    const hiddenPricesInput = document.querySelector('input[name="js-page-prices"]');

    const rawCount = hiddenCountInput ? parseInt(hiddenCountInput.value) : 50000;
    const pricesArray = hiddenPricesInput ? JSON.parse(hiddenPricesInput.value) : {};
    const currencyCode = pricesArray['CC'] ? pricesArray['CC'] : 'USD';

    const isUSD = currencyCode === 'USD';
    const formattedCount = isUSD
        ? rawCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : rawCount.toString();

    // Collect all counters
    const counterData = [];

    if (counter1) {
        counterData.push(Promise.resolve({ element: counter1, target: 120, isFormatted: false }));
    }
    if (counter2) {
        counterData.push(Promise.resolve({ element: counter2, target: formattedCount, isFormatted: isUSD }));
    }
    if (counter3) {
        counterData.push(Promise.resolve({ element: counter3, target: 24, isFormatted: false }));
    }
    if (counter4) {
        counterData.push(Promise.resolve({ element: counter4, target: 60, isFormatted: false }));
    }
    if (counter5) {
        counterData.push(Promise.resolve({ element: counter5, target: 5, isFormatted: false }));
    }

    // Animate all counters together
    Promise.all(counterData)
        .then(counters => {
            counters.forEach(({ element, target, isFormatted }) => {
                animateCounterSmooth(element, target, isFormatted);
            });
        })
        .catch(error => {
            console.error("Error in counter animation setup:", error);
        });
}

function animateCounterSmooth(element, target, isFormatted = false) {
    const numericTarget = isFormatted ? parseInt(target.toString().replace(/,/g, '')) : target;

    const maxDuration = 3000;
    const minDuration = 100;
    
    let duration;
    if (numericTarget <= 10) {
        duration = minDuration;
    } else if (numericTarget <= 100) {
        duration = Math.min(800, maxDuration);
    } else {
        duration = maxDuration;
    }
    
    if (element.id === 'counter5') duration = Math.min(600, duration);
    if (element.id === 'counter3') duration = Math.min(1000, duration);
    if (element.id === 'counter4') duration = Math.min(2000, duration);
    
    const startTime = performance.now();
    
    function updateCounter(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        const easeProgress = 1 - Math.pow(1 - progress, 3);
        
        const currentCount = Math.floor(numericTarget * easeProgress);
        
        element.textContent = isFormatted
            ? currentCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : currentCount;
        
        if (progress < 1) {
            requestAnimationFrame(updateCounter);
        } else {
            element.textContent = isFormatted
                ? numericTarget.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : numericTarget;
        }
    }
    
    requestAnimationFrame(updateCounter);
}

const validOrderFlowPages = [
    'order-now',
    'addon-page',
    'thank-you' // This will match all thank-you related pages
];

const currentPath = window.location.pathname;

const isInOrderFlow = validOrderFlowPages.some((page) =>
    currentPath.includes(page)
);

if (!isInOrderFlow) {
    sessionStorage.removeItem('back_from_addon');
    sessionStorage.removeItem('back_from_addon_order_id');
    sessionStorage.removeItem('back_from_thankyou');
    sessionStorage.removeItem('show_warning_after_reload');
}

/**
 * Add ARIA labels and accessibility enhancements
 * to any Owl Carousel instance.
 *
 * @param {string|HTMLElement|jQuery} selector - carousel element(s)
 */
function enhanceOwlAccessibility(selector) {
    const el = $(selector);
  
    // Wait until initialized to run
    el.on('initialized.owl.carousel', function () {
      const carousel = $(this);
  
      // Prev/Next buttons
      carousel.find('.owl-prev')
        .attr('aria-label', 'Previous slide')
        .append('<span class="sr-only">Previous slide</span>');
  
      carousel.find('.owl-next')
        .attr('aria-label', 'Next slide')
        .append('<span class="sr-only">Next slide</span>');
  
      // Dots
      carousel.find('.owl-dot').each(function (index) {
        $(this).attr('aria-label', 'Go to slide ' + (index + 1));
      });
    });
  }
  var $sliderhuman = $("#human-translator-slider");
  $sliderhuman.owlCarousel({
  loop: true,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  dots: true,
  nav: false,
  smartSpeed: 800,
  margin: 35,
  responsive: {
    0: {          // 0px start (mobile)
      items: 1
    },
    600: {        // 600px upar (tablet)
      items: 1
    },
    1000: {       // 1000px upar (desktop)
      items: 2
    }
  }
});
$sliderhuman.css("visibility", "visible");







  



